
import {
  PropType, defineComponent, computed, ref,
} from '@vue/composition-api';
import { analysisMap } from './analyses';
import RenderJsx from '../../utils/RenderJsx';
import { downloadSVG } from '../../utils/exporter';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    analysisPath: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    download: {
      default: false,
      type: Boolean,
    },
    downloadImpl: {
      default: null,
      type: Function as PropType<(arg0: HTMLElement) => {}>,
    },
  },
  components: {
    RenderJsx,
  },
  setup(props, { slots }) {
    const el = ref(document.createElement('div'));
    const hasControls = computed(() => !!slots.controls);
    const helpText = computed(() => {
      if (props.analysisPath) {
        return analysisMap[props.analysisPath].description;
      }
      return null;
    });
    function downloadImage() {
      if (props.downloadImpl) {
        props.downloadImpl(el.value);
        return;
      }
      const svg = el.value.querySelector('svg');
      if (svg) {
        downloadSVG(svg, props.title);
      }
    }
    return {
      el,
      hasControls,
      helpText,
      downloadImage,
    };
  },
});
